import { render, staticRenderFns } from "./package-form.vue?vue&type=template&id=aa580ee0&scoped=true"
import script from "./package-form.vue?vue&type=script&lang=js"
export * from "./package-form.vue?vue&type=script&lang=js"
import style0 from "./package-form.vue?vue&type=style&index=0&id=aa580ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa580ee0",
  null
  
)

export default component.exports